<p>manage-client-documents works!</p>
